"use client";

import styles from "./outro-blurb.module.scss";

function OutroBlurb() {
  return (
    <section className={styles.blurbContainer}>
      <p className={styles.blurbDescription}>
        <strong>PLEASE NOTE:</strong> PeatSense is currently in BETA mode. This
        means that some functionalities might be missing or buggy. Please let us
        know if you find anything weird and if you think new functionalities are
        needed!
      </p>
    </section>
  );
}

export default OutroBlurb;
